import React from 'react';
import CountDown from 'react-simple-countdown';

function finish() {
  console.log('Countdown finished');
}

const MyComponent = () => {
  // i18n or custom messages
  const messages = {
    days: {
      plural: ' Días',
      singular: ' Día',
    },
    hours: ' Horas',
    mins: ' Min',
    segs: ' Segundos',
  }
  return (
    <CountDown
      date="2017-12-31"
      className="MyCoundown"
      {...messages}
      onEnd={finish}
    />
  );
}

export default MyComponent


// WEBPACK FOOTER //
// ./src/components/countdown.js